var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm._.get(_vm.company, 'accountStatus.disabledSince', false))?_c('v-icon',{attrs:{"color":"accent"}},[_vm._v("report")]):(_vm._.get(_vm.company, 'accountStatus.verified', false))?_c('v-icon',{attrs:{"color":"green"}},[_vm._v("verified_user")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.company.displayName))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b84020d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CompanyName.vue
// module id = null
// module chunks = 